import imm from 'immutable';

export default {
  CONSTRUCT() {
    return {
      filter: '',
      available: {}
    };
  },
  UPDATE_TAG_AUTOCOMPLETE(state, filter) {
    return state.set('filter', filter);
  },
  ADD_TAGS(state, tags) {
    return state.update('available', val => val.mergeWith((old_val, new_val) => old_val, tags));
  },
  SET_TAGS(state, tags) {
    return state.set('available', imm.fromJS(tags));
  },
  ADD_TAG_FILTER(state, tag) {
    return state.update('available', val => val.set(tag, false)).set('filter', '');
  },
  REMOVE_TAG_FILTER(state, tag) {
    return state.update('available', val => val.set(tag, true));
  },
  CLEAR_TAGS(state) {
    return state.set('available', imm.fromJS({}));
  }
};
